<template>
	<div class="overview" v-if="loaded">
		<div class="tiles">
			<a :href="'/travel/' + travel.alias"
			   class="tile" v-for="(travel) in travels"
			   :key="travel.id"
			   :style="getStyle( travel )"
			   :title="getTitle( travel )"
			   @click.prevent="showTravel(travel.alias)">
				<h2>{{travel.title}}</h2>
			</a>
		</div>
	</div>
</template>

<script>
import Vue from "vue";

export default {
	name: "Overview",
	computed: {
		loaded() {
			const loaded = this.$store.getters["content/hasContent"];

			if ( loaded ) {
				this.$nextTick( () => document.dispatchEvent( new Event( "x-app-rendered" ) ) );
			}

			return loaded;
		},
		travels() {
			return ( this.$store.state.content.content || [] ).sort( ( l, r ) => l.sorting - r.sorting );
		},
	},
	methods: {
		getStyle( travel ) {
			const image = travel.elements.find( el => el.type === "image" );
			if ( image ) {
				return {
					backgroundImage: "url(" + Vue.config.mediaBackendUrl + image.singleSRC + ")",
				};
			}

			return null;
		},
		getTitle( travel ) {
			const image = travel.elements.find( el => el.type === "image" );
			if ( image ) {
				return image.meta && image.meta.de && image.meta.de.title;
			}

			return null;
		},
		showTravel( alias ) {
			this.$router.push( {
				name: "profile",
				params: { alias: alias }
			} );
		},
	}
};
</script>

<style scoped lang="scss">
	@import "../assets/variables";

	.overview {
		@include viewWidth;
	}

	.tiles {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;

		.tile {
			position: relative;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center center;
			width: 50%;
			height: 280px;
			min-height: 50vh;
			cursor: pointer;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			transition: transform 150ms ease, box-shadow 150ms ease;
			color: inherit;
			text-decoration: none;

			h2 {
				@include font( $size:4rem, $height:150%, $weight:bold );

				margin: 0;
				padding: 0 20px;
				background-color: #00000030;
				color: white;
				text-shadow: 0 0 2px #000000c0;
				text-align: center;
				transition: background-color 150ms ease;
			}

			&:hover {
				z-index: 1;
				transform:scale(1.01);
				box-shadow: 0 0 10px 1px rgba(0,0,0,0.5);

				h2 {
					background-color: #ffffff30;
				}
			}
		}
	}

	@include tablet {
		.tiles .tile {
			width: 100%;

			h2 {
				font-size: 3rem;
			}
		}
	}
</style>
